/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_BEFORE_LEAVING_STATE,
  RESET_AFTER_LEAVING_STATE,
  RESET_SPECIAL_EVENT_STATE,
  RESET_PELEVANT_PERSON_STATE,
  RESET_TRAVEL_AGENT_STATE,
  RESET_SPECIAL_EVENT_AL_STATE,
  RESET_PELEVANT_PERSON_AL_STATE,
  RESET_CUTTING_YOU_TRIP_STATE,
  RESET_TRAVEL_INTERRUPTION_STATE,
  RESET_THE_RELEVANT_PERSON_STATE,
  RESET_RESUMING_YOUR_TRIP_BACK_OVERSEAS_STATE,
  RESET_TRAVEL_PLANS_ORGANISED_BY_A_TRAVEL_AGENT,
  RESET_TRAVEL_AGENT_CANCELLATION_FEE,
  RESET_PELEVANT_PERSON_EXISTING_HEALTH_AL_STATE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormBeforeLeaving() {
  return {
    type: RESET_BEFORE_LEAVING_STATE,
  };
}

export function resetFormSpecialEvent() {
  return {
    type: RESET_SPECIAL_EVENT_STATE,
  };
}

export function resetFormRelevantPerson() {
  return {
    type: RESET_PELEVANT_PERSON_STATE,
  };
}

export function resetFormTheTravelAgent() {
  return {
    type: RESET_TRAVEL_AGENT_STATE,
  };
}

export function resetFormAfterLeaving() {
  return {
    type: RESET_AFTER_LEAVING_STATE,
  };
}

export function resetFormSpecialEventAL() {
  return {
    type: RESET_SPECIAL_EVENT_AL_STATE,
  };
}

export function resetFormRelevantPersonAL() {
  return {
    type: RESET_PELEVANT_PERSON_AL_STATE,
  };
}

export function resetFormRelevantPersonExistingHealthConditionAL() {
  return {
    type: RESET_PELEVANT_PERSON_EXISTING_HEALTH_AL_STATE,
  };
}

export function resetFormCuttingYourTrip() {
  return {
    type: RESET_CUTTING_YOU_TRIP_STATE,
  };
}

export function resetFormTravelInterruption() {
  return {
    type: RESET_TRAVEL_INTERRUPTION_STATE,
  };
}

export function resetFormResumingYourTripBackOverseas() {
  return {
    type: RESET_RESUMING_YOUR_TRIP_BACK_OVERSEAS_STATE,
  };
}

export function resetFormTheRelevantPersonsExistingHealthCondition() {
  return {
    type: RESET_THE_RELEVANT_PERSON_STATE,
  };
}

export function resetFormWereAnyOfYourTravelPlansOrganisedByATravelAgentPI() {
  return {
    type: RESET_TRAVEL_PLANS_ORGANISED_BY_A_TRAVEL_AGENT,
  };
}

export function resetFormWereYouChargedACancellationFeeByTheTravelAgentPI() {
  return {
    type: RESET_TRAVEL_AGENT_CANCELLATION_FEE,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.ChangesToYourJourney/actions.js